export default __webpack_public_path__ + "static/media/Logo_Sol_Phantoms_Twitter-01-01.6c8b0578.png";